import { render, staticRenderFns } from "./VirtualAssistSummary.vue?vue&type=template&id=09786a04&scoped=true"
import script from "./VirtualAssistSummary.vue?vue&type=script&lang=ts"
export * from "./VirtualAssistSummary.vue?vue&type=script&lang=ts"
import style0 from "./VirtualAssistSummary.vue?vue&type=style&index=0&id=09786a04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09786a04",
  null
  
)

export default component.exports